import React from 'react';
import { observer } from 'mobx-react-lite';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import { useNotifications } from '../../../../../shared/ui/hooks/useNotifications';
import { ExternalNotification } from '../../../../../shared/infrastructure/types/common/common-types';

let LoginNotifications = function (): React.ReactElement {
  const { authorizationUiModule } = useUILogic();

  useNotifications<ExternalNotification | undefined>({
    notificationsList: authorizationUiModule.notificator.externalNotifications,
    getNotification: () => authorizationUiModule.notificator.popExternal(),
  });

  return <></>;
};

LoginNotifications = observer(LoginNotifications);

export { LoginNotifications };
